import React from 'react';
import PropTypes from 'prop-types';
import OrganizationData from './OrganizationData';
import ProductData from './ProductData';
import BreadcrumbsData from './BreadcrumbsData';
import PersonData from './PersonData';

const StructuredData = ({ type, ...data }) => {
  if (type === 'organization') {
    return <OrganizationData {...data || {}}/>;
  } else if (type === 'product') {
    return <ProductData {...data || {}}/>;
  } else if (type === 'breadcrumbs') {
    return <BreadcrumbsData {...data || {}} />;
  } else if (type === 'person') {
    return <PersonData {...data || {}} />;
  }

  return null;
};

StructuredData.propTypes = {
  type: PropTypes.oneOf(['organization', 'product', 'breadcrumbs', 'person']),
};

export default StructuredData;
